//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoginActivateVue from './LoginActivate.vue'
import LoginSmsVue from './LoginSms.vue'
import LoginWechatVue from './LoginWechat.vue'

export default {
  components: { LoginSmsVue, LoginWechatVue, LoginActivateVue },
  data() {
    return {
      loginMode: 'WECHAT',
      inactivatedUserInfo: null,
    }
  },

  computed: {
    title() {
      switch (this.loginMode) {
        case 'WECHAT':
          return '微信二维码登录'
        case 'SMS':
          return '手机短信登录'
        case 'ACTIVATE':
          return '请输入邀请码'
        default:
          return '手机短信登录'
      }
    },

    button() {
      switch (this.loginMode) {
        case 'WECHAT':
          return '手机短信登录'
        case 'SMS':
          return '微信二维码登录'
        case 'ACTIVATE':
          return '返回登录'
        default:
          return '微信二维码登录'
      }
    },

    shouldRenderButton() {
      return window.__wxjs_environment !== 'miniprogram'
    },
  },

  methods: {
    toggleMode() {
      switch (this.loginMode) {
        case 'WECHAT':
          this.loginMode = 'SMS'
          break
        case 'SMS':
          this.loginMode = 'WECHAT'
          break
        case 'ACTIVATE':
          this.loginMode = 'WECHAT'
          break
        default:
          return
      }
      this.inactivatedUserInfo = null
    },

    gotoActivate(newUserInfo) {
      this.inactivatedUserInfo = newUserInfo
      this.loginMode = 'ACTIVATE'
    },
  },

  created() {
    const u = this.$route.params.userInfo
    if (u && !u.activated) {
      this.gotoActivate(u)
    }
  },
}
